import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { utilities } from "../../../utilities/utlities";
import api from '../api'
import { useNavigator } from "../../../utilities/navigation";
import './styles.css'
import { Divider, Layout, message, Space, Table, Tabs, Typography,Button} from "antd";
const Profiles = (props) => {
    const [navigator] = useNavigator()
    const { Content } = Layout
    const [loading, setLoading] = useState(false)
    // const {Link} = Typography
    const [data, setData] = useState([])
    const [activeFilter, setActiveFilter] = useState('')
    const { type } = useParams();
    const columns = [
        {
            title: 'Company Name',
            dataIndex: 'companyName',
            // sorter: (a, b) => a.title.length - b.title.length,
            render: (item,obj) => {
                return(
                    <Link to={"/profile/edit/"+obj?.owner?._id}>{item}</Link>
                )
            }
        },
        {
            title: 'Name',
            dataIndex: 'firstName',
            // sorter: (a, b) => a.title.length - b.title.length,
            render: (item,obj) => {
                return(
                    <Text>{`${obj?.owner?.firstName}  ${obj?.owner?.lastName}`}</Text>
                )
            }
        },
        {
            title: 'Owner',
            dataIndex: 'firstName',
            // sorter: (a, b) => a.title.length - b.title.length,
            render: (item,obj) => {
                return(
                    <Text>{obj?.owner?.firstName}</Text>
                )
            }
        },
        {
            title: 'Email',
            dataIndex: 'email',
            render: (item,obj) => {
                return(
                    <Text>{obj?.owner?.email}</Text>
                )
            }
        },
        {
            title:'Actions',
            render: (item,obj) => {
                return(<Link to={"/profile/edit/"+obj?.owner?._id}>View Profile</Link>
                )
            }
        }
    ]
    useEffect(()=>{
        let filter = 'pending'
        let filterParam = utilities.getParameterByName('filter')
        if(filterParam){
            filter = filterParam
            setActiveFilter(filter)
        }
        getProfiles(type,filterParam)
    },[type])
    const getProfiles = (type,filter='pending') => {
        setLoading(true)
        api.getProfiles((error,res)=>{
            setLoading(false)
            if(error){
                message.error('Something went wrong',2)
            }else{
                setData(res)
            }
        },type,utilities.loggedUser().jwtToken,filter)
    }
    const onTabChanged = (key) => {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?filter='+key;
        window.history.pushState({path:newurl},'',newurl);
        getProfiles(type,key)
        setActiveFilter(key)
    }
    const { Text, Title } = Typography
    const { TabPane } = Tabs;
    return(
        <Layout className="layout">
            <Content style={{padding: '0 0',justifyContent: 'flex-start'}} className = "site-layout-content">
                <div className="profiles_title"><Title level={4}>{type === 'distributor' ? 'Distributors' : 'Suppliers'}</Title></div>
                <div className="profiles_table">
                <Space style={{width: '100%'}} direction='vertical' size={8}>
                    <Tabs activeKey={activeFilter} defaultActiveKey='pending' onChange={onTabChanged}>
                        <TabPane tab="Pending" key="pending"></TabPane>
                        <TabPane tab="Approved" key="approved"></TabPane>
                        <TabPane tab="Rejected" key="rejected"></TabPane>
                    </Tabs>
                    <Table loading = {loading} style={{width: '100%'}} dataSource = {data} columns = {columns}/>
                </Space>
                </div>
            </Content>
        </Layout>
    )
}
export default Profiles